// extracted by mini-css-extract-plugin
export default {"CategoriesContainer":"CategoriesContainer_CategoriesContainer__sJ11V"};